import { useMutation } from '@tanstack/react-query';
import { inboxFeatureStore } from '../../../features/Inbox/store';
import { apiClient, getEndpoints } from '../../common';
import { ACCESS_REQUESTED_NAMESPACE } from './constants';
import { invalidateNotificationListQuery } from './utils';

interface IUseApplyAccessRequestParams {
	id?: string;
}

export function useApplyAccessRequest({ id }: IUseApplyAccessRequestParams) {
	const mutationFn = async () => {
		if (!id) {
			return null;
		}

		const url = `${getEndpoints(ACCESS_REQUESTED_NAMESPACE).byId(id)}apply`;

		const { data } = await apiClient.post(url);
		return data;
	};

	const mutation = useMutation({
		mutationKey: ['applyAccessRequest', id],
		mutationFn,
		onSuccess: () => {
			if (id && !inboxFeatureStore.showRead) {
				inboxFeatureStore.addToRecentlyRead(id);
			}
			invalidateNotificationListQuery();
		},
	});

	return {
		...mutation,
		isApplied: mutation.isSuccess,
	};
}
